<div>
  <mat-icon>translate</mat-icon>
  <mat-menu #langMenu="matMenu" class="lang-menu">
    <button
      mat-menu-item
      *ngFor="let lang of langs"
      (click)="setLocale(lang.locale)"
      class="lang-option"
      [ngClass]="{ 'lang-selected': lang.locale === currentLocale }"
    >
      <img
        width="32"
        height="32"
        [src]="'assets/images/flags/' + lang.locale + '.png'"
        [alt]="lang.locale"
      />&nbsp;
      {{ lang.name }}
    </button>
  </mat-menu>
</div>
